import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import Bodyaction from "./Bodyaction";
import Sociro from "./Sociro";
import HighBurgerGta from "./HighBurgerGta";
import NewEra from "./NewEra";
import SportNutrition from "./SportNutrition";
import Footer from "../Footer";
import SobreHome from "./SobreHome";
import DiretoresHome from "./DiretoresHome";
import Header from "../Header";
import ProjetosHome from "./ProjetosHome";
import ContatoHome from "./ContatoHome";
import Rexona from "./Rexona";
import King from "./King";
import Extremos from "./Extremos";
import Maiale from "./Maiale";
import OGol from "./OGol";
import AirmaxDay from "./AirmaxDay";
import SomosInter from "./SomosInter";
import JohnnieWalker from "./JohnnieWalker";

export default function Home() {
  const [itemClick, setItemClick] = useState("");
  const ref = useRef(null);

  const vaiAte = (local) => {
    const divPosition = document.getElementById(local).offsetTop;
    window.scrollTo({
      top: divPosition,
      behavior: "smooth",
    });
  };

  useEffect(() => {}, []);

  return (
    <>
      <Header vaiAte={vaiAte} />
      <OGol />
      <AirmaxDay />
      <SomosInter />
      <JohnnieWalker />
      <King />
      <Maiale />
      {/* <Extremos />  */}
      {/* <Rexona /> */}
      <Bodyaction />
      {/* <Sociro /> */}
      <HighBurgerGta />
      {/* <NewEra /> */}
      <SportNutrition />
      <div id="sobreHome" className="d-flex d-md-none flex-column">
        <SobreHome />
      </div>
      <div id="diretoresHome" className="d-flex d-md-none flex-column">
        <DiretoresHome />
      </div>
      <div id="projetosHome">
        <ProjetosHome />
      </div>
      <div id="contatoHome" className="d-flex d-md-none flex-column">
        <ContatoHome />
      </div>
      <Footer />
    </>
  );
}
